import React from 'react';
import AgentsContent from './AgentsContent';
import Tools from './Tools';
import Marketing from './Marketing';
import Settings from './Settings';
import TranscriptionTool from './TranscriptionTool';

const MainContent = ({ selectedService }) => {
  return (
    <div className="flex-grow-1 overflow-auto">
      <div className="bg-white shadow p-4 d-flex align-items-center">
        <h1 className="fs-4 fw-medium mb-0">{selectedService}</h1>
      </div>
      <ContentRenderer service={selectedService} />
    </div>
  );
};

const ContentRenderer = ({ service }) => {
  switch (service) {
    case 'Agents':
      return <AgentsContent />;
    case 'Tools':
      return <Tools />;
    case 'Marketing':
      return <Marketing />;
    case 'Settings':
      return <Settings />;
    case 'Transcription':
      return <TranscriptionTool />;
    default:
      return <div className="p-6">Select a service</div>;
  }
};

export default MainContent;